import React from "react";
import './home.css';
import fotoa from '../images/explore/rapeles_salto/rappelb.jpg'
import fotob from '../images/cycle/mtb-bb.jpg'
import fotoc from '../images/img-ab.jpg'

const Home = () => {
  return(
      <div className="bg-white">
      
        <main className="h-100 d-md-inline-block">
          <div className="hero text-muted h-100 d-md-inline-block">
            <h1>lifetime experiences</h1>
            <p>get there... see what's beyond....</p>
            <img alt="" src={require('../images/img.JPG')} />
          </div>
        </main>
      
        <div className="row d-flex m-0">

          <div className="flex-column text-center element col-xs-12 col-sm-12 col-md-4 col-lg-4 p-0">
            <div className="v_align">
              <h2 className="text-dark">
                <p style={{fontSize:'4vw'}}>TIRIKA EXPEDITIONS</p>
                <p style={{fontSize:'4vw'}}></p>
                <p style={{fontSize:'3vw'}}>choose your adventure!!</p>
                <p style={{fontSize:'3vw'}}>we'll do the rest</p>
                <a href="/our_team" className="rounded-0 btn btn-lg btn-primary btn-block">Meet the team</a>
              </h2>
              
            </div>
            
          </div>
      
          <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 px-0 pb-lg-1 pb-xl-1 pb-md-1 pb-xs-0 pb-sm-0">
            <div className="embed-responsive embed-responsive-16by9 text-center">
              <iframe title="video" className="embed-responsive-item pl-xs-0 pl-sm-0 pl-md-1 pl-lg-1 pr-0" src="https://www.youtube.com/embed/C_s-MNZAVjs?rel=0" allowFullScreen></iframe>
            </div>
          </div>
      
        </div>


        <div className="text-center bg-light pt-1">
          <h1 className="text-dark" style={{fontSize:'3.5vw'}}>
          Travel the untouched Venezuela
          </h1>
        </div>


        <div className="row m-0 p-0 justify-content-around">
          
          <div className="border-0 text-light col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
          <a href="/angel_falls_abseil" className="">
            <img className="img-fluid card-img rounded" src={fotoa} alt=""/>
            <div className="text-light card-img-overlay subhero-a p-2 m-2">
              <h5 className="card-title">Angel Falls abseil</h5>
              <p className="card-text">Feel the void!! Descend more than 3,000 feet just beside the highest waterfall on the planet.</p>
            </div>
          </a>
          </div>
 
          <div className="border-0 text-dark col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
          <a href="/cycle" className="">
            <img className="img-fluid card-img rounded" src={fotob} alt=""/>
            <div className="card-img-overlay subhero-b">
              <h5 className="card-title text-dark">Multi-day bike trips</h5>
              <p className="card-text text-light">Peerless remote bike tracks. Breathtaking landscapes.</p>
            </div>
          </a>    
          </div>

          <div className="border-0 text-light col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-2 m-0">
          <a href="/lost_world" className="">
            <img className="img-fluid card-img rounded" src={fotoc} alt=""/>
            <div className="text-light card-img-overlay subhero-c">
              <h5 className="card-title">The Lost World</h5>
              <p className="card-text">Discover one of the oldest places on earth.</p>
            </div>
          </a>  
          </div>

        </div>

        
      </div>
  );
};

export default Home;


// WEBPACK FOOTER //
// ./src/components/home.jsx